import { useMutation, UseMutationResult, useQueryClient } from 'react-query';

import { getTokenWithType } from './useAuth';

import { deleteTemplate } from '../utils/urls';

import { ErrorModal } from 'types/modalTypes';

export async function postDeleteTemplate({
  accountId,
  params,
}: TVariables): Promise<TResult> {
  const response = await fetch(deleteTemplate(accountId), {
    method: 'DELETE',
    headers: {
      Authorization: getTokenWithType(),
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(params),
  });
  return response.json();
}

type TError = ErrorModal;

type TResult = {
  Data: string;
  IsSuccess: boolean;
  StatusCode: number;
} & ErrorModal;

type TVariables = {
  accountId: number;
  params: {
    Title: string;
    Container: string;
    IsDeleteFromAllFolder: boolean;
  };
};

type TSnapshot = unknown;

function useDeleteTemplate(): UseMutationResult<
  TResult,
  TError,
  TVariables,
  TSnapshot
> {
  const queryClient = useQueryClient();
  return useMutation(async ({ accountId, params }: TVariables) => {
    const { Container } = params;
    const renamedResult = await postDeleteTemplate({ accountId, params });

    if (renamedResult.Data) {
      if (Container === 'layouts') {
        queryClient.invalidateQueries(
          ['getExistingTemplates', true, accountId, 'layouts'],
          {
            refetchInactive: true,
          },
        );
      } else if (Container === 'tables') {
        queryClient.invalidateQueries(
          ['getExistingTemplates', true, accountId, 'tables'],
          {
            refetchInactive: true,
          },
        );
      }
    } else if (renamedResult.Errors) throw renamedResult;
    return renamedResult;
  });
}

export { useDeleteTemplate };
